import React, { createContext, useContext, useState, useEffect } from 'react';

interface AutoScrollContextType {
  autoScrollEnabled: boolean;
  setAutoScrollEnabled: (enabled: boolean) => void;
}

const AutoScrollContext = createContext<AutoScrollContextType | undefined>(undefined);

export const useAutoScroll = () => {
  const context = useContext(AutoScrollContext);
  if (!context) {
    throw new Error('useAutoScroll must be used within an AutoScrollProvider');
  }
  return context;
};

interface AutoScrollProviderProps {
  children: React.ReactNode;
}

export const AutoScrollProvider: React.FC<AutoScrollProviderProps> = ({ children }) => {
  // Load preference from localStorage
  const [autoScrollEnabled, setAutoScrollEnabled] = useState(() => {
    const saved = localStorage.getItem('autoScrollEnabled');
    return saved !== null ? JSON.parse(saved) : true; // Default to enabled
  });

  // Save preference to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('autoScrollEnabled', JSON.stringify(autoScrollEnabled));
  }, [autoScrollEnabled]);

  const value: AutoScrollContextType = {
    autoScrollEnabled,
    setAutoScrollEnabled,
  };

  return (
    <AutoScrollContext.Provider value={value}>
      {children}
    </AutoScrollContext.Provider>
  );
};